import { ApiError, ValidationError } from "./errors";

export const handleErrorResponse = async (response: Response): Promise<never> => {
  const errorData = await response.text().then(text => {
    try {
      return JSON.parse(text);
    } catch {
      return { Message: text || 'Request failed' };
    }
  });

  if (response.status === 400) {
    throw new ValidationError(
      errorData.Message || 'Invalid input',
      errorData.StatusCode || response.status,
      errorData.Details
    );
  }
  
  throw new ApiError(
    errorData.Message || `HTTP error! status: ${response.status}`, 
    errorData.StatusCode || response.status
  );
};


export const parseSuccessResponse = async (response: Response): Promise<any> => {
  const contentType = response.headers.get('content-type');
  if (contentType && contentType.includes('application/json')) {
    return await response.json();
  } else {
    const textContent = await response.text();
    return { success: true, message: textContent || 'Request successful' };
  }
};